// extracted by mini-css-extract-plugin
var _1 = "pfx-OrderedList-module__container--PEYkb";
export { _1 as "container" }
